import React from 'react';
import cn from 'classnames';

import { ICloseButtonProps } from './CloseButton.types';

import './CloseButton.scss';

const CloseButton: React.FC<ICloseButtonProps> = ({ onClick, className }) => {
	const handleClick = (e: React.SyntheticEvent) => {
		e.stopPropagation();
		onClick();
	};

	return (
		<div
			className={cn('f5gCloseIcon', className)}
			data-testid='btn-close'
			onClick={handleClick}
		>
			<span>&times;</span>
		</div>
	);
};

export default CloseButton;
